import { useState, useEffect } from 'react'

export type Scroll = {
  scrollX: number
  scrollY: number
}

const getScroll = (): Scroll => ({
  scrollX: window.scrollX || 0,
  scrollY: window.scrollY || 0
})

export function useWindowScroll(onlyOnScrollEnd = true, cb?: (p: Scroll) => void) {
  const [windowScroll, setWindowScroll] = useState(getScroll())

  useEffect(() => {
    let scrollId: number | undefined = undefined

    const handleScroll = () => {
      const scroll = getScroll()
      if (onlyOnScrollEnd) {
        window.clearTimeout(scrollId)
        scrollId = window.setTimeout(() => {
          setWindowScroll(scroll)
          if (cb) cb(scroll)
        }, 200)
      } else {
        setWindowScroll(scroll)
        if (cb) cb(scroll)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return windowScroll
}
